import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MdEdit } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { QrCode } from 'src/assets/images';
import Card from 'src/components/card';
import CrudIcon from 'src/components/crud-icon';
import Loader from 'src/components/loader';
import Service from 'src/setup/network';
import * as Yup from 'yup';
import AddPayment from './addPayment';

interface IProps {
  allowedPaymentTypes?: any;
  loading?: boolean;
  setForceUpdate?: any;
}

const FORM_VALIDATION = Yup.object().shape({});

const PaymentMethod: React.FC<IProps> = ({
  allowedPaymentTypes,
  loading,
  setForceUpdate,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [qrData, setQrData] = useState([]);
  const [qrEditData, setQrEditData] = useState([]);
  const [qrEdit, setQrEdit] = useState(false);
  const [showIcon, setShowIcon] = useState(null);
  const [selectedQrData, setSelectedQrData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPaymentTypes, setselectedPaymentTypes] = useState<any>([]);

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const fetchQrData = async () => {
    try {
      const response = await Service.get('/settings/paymentMethod');
      setQrData(response?.data?.qrs);
    } catch (err) {}
  };
  const fetchSelectedQr = async () => {
    setIsLoading(true);
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '');
    try {
      const response = await Service.get(
        `/settings/paymentMethod/selected/all/${userInfo.businessInfo.id}`
      );
      setSelectedQrData(response?.data?.qrs);
      await response.data?.qrs.map((el: any) => {
        if (el.isSelected) {
          selectedPaymentTypes.push(el?.id);
        }
      });
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedQrData?.length > 0) return;
    fetchQrData();
    fetchSelectedQr();
  }, []);

  const initValues = {
    selectedPaymentTypes: selectedPaymentTypes,
  };
  const handleImageClick = async (data: any) => {
    // setQrEdit(!qrEdit);
    // setQrEditData(data);
    // {
    //   data?.isEditable && setShowModal(true);
    // }

    const paymentType = data?.value;
    if (selectedPaymentTypes.includes(data?.id)) {
      setselectedPaymentTypes((prev: any) =>
        prev.filter((el: any) => el !== data?.id)
      );
    } else {
      setselectedPaymentTypes((prev: any) => [...prev, data?.id]);
    }

    try {
      const response = await Service.put(`/settings/paymentMethod/${data?.id}`);
    } catch (err) {}
  };

  const handleSubmit = async (values: any, { resetForm }: any) => {
    // const payload = {
    //   allowedPaymentTypes: {
    //     delivery: selectedPaymentTypes?.includes('delivery') ? true : false,
    //     dine_in: selectedPaymentTypes?.includes('dine_in') ? true : false,
    //     takeaway: selectedPaymentTypes?.includes('takeaway') ? true : false,
    //     online_order: false,
    //   },
    // };
    // try {
    //   await Service.post('/settings/update', payload);
    //   toastAlert('success', `Payment methods are successfully updated`);
    //   dispatch(fetchDetails() as any);
    // } catch (err: any) {
    //   toastAlert('error', err?.response?.data?.message);
    // }
  };

  const handleAddQr = () => {
    setQrEditData([]);
    setShowModal(!showModal);
  };

  const handleEditPayments = (data: any) => {
    setShowIcon(null);
    setQrEdit(!qrEdit);
    setQrEditData(data);
    {
      (data?.isEditable || data?.needsQr) && setShowModal(true);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={FORM_VALIDATION}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              <div className="flex flex-wrap">
                {qrData &&
                  qrData.map((el: any) => {
                    return (
                      <div key={el?.id}>
                        <Card className={`relative  w-[140px] h-[170px] mr-7`}>
                          <div>
                            {el?.needsQr && (
                              <div className="h-6 w-6 absolute  left-2 top-2 ">
                                <img src={QrCode} alt="" />{' '}
                              </div>
                            )}
                          </div>

                          {(el?.needsQr || el?.isEditable) && (
                            <>
                              <div
                                className=" absolute right-1 top-2 z-10"
                                onClick={() =>
                                  setShowIcon(
                                    showIcon === el?.id ? null : el?.id
                                  )
                                }
                              >
                                <BsThreeDotsVertical
                                  size={20}
                                  style={{ color: '#949CC0' }}
                                />
                              </div>
                              <div className="mt-2 absolute right-0 top-5 p-2 px-4 z-10  ">
                                {showIcon == el?.id && (
                                  <div className="border border-[#949CC0] bg-[white]  p-1 rounded ">
                                    <CrudIcon
                                      data={el}
                                      url="/settings/paymentMethod"
                                      fetchData={fetchQrData}
                                    >
                                      <div
                                        className="w-7 m-0 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
                                        onClick={() => handleEditPayments(el)}
                                      >
                                        <MdEdit size={16} color="#4062FF" />
                                      </div>
                                    </CrudIcon>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          <div
                            onClick={() => handleImageClick(el)}
                            className={` ${
                              selectedPaymentTypes.includes(el?.id)
                                ? 'border-[2px] rounded-xl border-primary w-[140px] h-auto cursor-pointer'
                                : ''
                            }} absolute top-0 left-0 pt-6 pl-4  w-[140px] min-h-full h-auto cursor-pointer`}
                          >
                            <img
                              src={el?.logo}
                              alt=""
                              className="w-20 h-20 ml-3 mt-3"
                            />
                            <p className="text-center mt-1 -ml-4 px-0.5 py-1.5">
                              {el?.name && el.name.length > 18
                                ? el.name.slice(0, 16) + '...'
                                : el.name}
                            </p>
                          </div>
                        </Card>
                      </div>
                    );
                  })}

                {/* Uncomment this to show add payment methods   */}
                <div>
                  <Card className="w-[140px]  relative h-[170px] cursor-pointer mr-6">
                    <div
                      className="w-full flex justify-center items-center h-full  text-[white] "
                      onClick={() => handleAddQr()}
                    >
                      <AiOutlinePlus
                        size={80}
                        className="bg-primary  rounded-full"
                      />
                    </div>
                  </Card>
                </div>
              </div>
              {/* <div className="flex items-center justify-end mr-5">
                <Button
                  text="Save Details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div> */}
            </Form>
          )}
        </Formik>
      )}
      <AddPayment
        qrEdit={qrEdit}
        qrEditData={qrEditData.length !== 0 && qrEditData}
        qrData={qrData}
        showModal={showModal}
        fetchData={() => fetchQrData()}
        handleModal={handleModal}
      />
    </>
  );
};

export default React.memo(PaymentMethod);
